<template>
	<div>
		<legacy-workbench v-if="useLegacy" />
	<div v-else class="workbench">
		<div class="workbench-header">
			<div class="welcome-section">
				<div class="welcome-icon">
					<i class="el-icon-sunny"></i>
				</div>
				<div class="welcome-text">
					<h1>欢迎您，{{ userChName }}</h1>
					<p>登录门店订单管理系统</p>
				</div>
			</div>
		</div>

		<div class="home-toolbar"><span>{{ templateName }}</span><el-button size="small" icon="el-icon-refresh" :loading="loading" @click="loadHome">刷新</el-button></div>
		<div v-loading="loading">
			<el-alert v-if="loadError" :title="loadError" type="error" :closable="false" />
			<div v-else class="home-grid"><home-widget v-for="item in groupedItems" :key="item.keyId" :placement="item.placement" :widget="item.widget" :children="item.children" :retrying="retrying" :value="item.value" :error="item.error" :path="item.path" :loading="retrying === item.keyId" :style="{gridColumn:item.placement.col+'/span '+item.placement.width,gridRow:item.placement.row}" @retry="retry($event || item)" /></div>
			<el-empty v-if="!loading && !loadError && !items.length" description="暂无可展示的首页统计内容" />
		</div>
	</div>
	</div>
</template>

<script>
import LegacyWorkbench from "./legacyWorkbench.vue";
import HomeWidget from "./homeWidget.vue";
import { groupHomeItems } from "@/utils/homeLayout";
import { homePageRequest } from "@/api/homePageApi";
export default {
	data() {
		return {
			userChName: "用户",
			roleName: "角色",
			deptName: "部门",
			useLegacy: false, templateName: "工作台", items: [], loading: false, loadError: "", retrying: "", requestVersion: 0
		};
	},
	components: {
		HomeWidget, LegacyWorkbench
	},

	computed: { groupedItems() { return groupHomeItems(this.items); } },
	created() {
		this.GetUserInfo();
		this.loadHome();
	},
	activated() { if (this.initialHomeLoaded) this.loadHome(); },
	beforeDestroy() { this.requestVersion++; },

	mounted() {},

	methods: {
		shouldUseLegacy(data) {
			// 新接口以实时角色配置为准；旧接口缺少标记时兼容登录返回的角色信息。
			if (typeof data.useLegacy === "boolean") return data.useLegacy;
			let loginInfo;
			try { loginInfo = JSON.parse(localStorage.getItem("userdata") || "null"); } catch (e) { loginInfo = null; }
			const templateId = loginInfo && loginInfo.roleInfo && loginInfo.roleInfo.homePageTemplateKeyId;
			return !templateId || !String(templateId).trim();
		},
		async loadHome() {
			const version = ++this.requestVersion;
			this.loading = true; this.loadError = ''; this.items = [];
			try { const data = await homePageRequest('Home'); if(version !== this.requestVersion) return; this.useLegacy = this.shouldUseLegacy(data); this.templateName = data.name; this.items = data.items; }
			catch(e) { if(version === this.requestVersion) this.loadError=e.message; }
			finally { if(version === this.requestVersion) { this.loading=false; this.initialHomeLoaded=true; } }
		},
		async retry(item) {
			if(this.retrying) return; const version=this.requestVersion; this.retrying=item.keyId;
			try { const data=await homePageRequest('Home',{keyId:item.keyId}); if(version !== this.requestVersion)return; const fresh=data.items.find(x=>x.keyId===item.keyId); if(fresh) Object.assign(item,{value:fresh.value,error:fresh.error}); else this.loadHome(); }
			catch(e) { this.$message.error(e.message); } finally { this.retrying=''; }
		},
		GetUserInfo() {
			let userdata = JSON.parse(localStorage.getItem("userdata"));
			if (userdata) {
				this.userChName = userdata.userInfo.chName;
				this.roleName = userdata.roleInfo.roleName;
				this.deptName = userdata.userInfo.dept;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.home-toolbar { display:flex; align-items:center; justify-content:space-between; margin:16px 0; color:var(--app-text-secondary); }
.home-grid { display:grid; grid-template-columns:repeat(12,minmax(0,1fr));gap:16px; }
@media(max-width:900px) { .home-grid { display:flex; flex-direction:column; } }
.workbench {
	width: 100%;
	height: calc(100vh - 75px);
	background: linear-gradient(180deg, var(--app-primary-soft) 0%, var(--app-surface-muted) 100%);
	padding: 16px;
	box-sizing: border-box;
	overflow-y: auto;
	position: relative;
}

.workbench-header {
	margin-bottom: 16px;
}

.welcome-section {
	display: flex;
	align-items: center;
	background: linear-gradient(135deg, var(--app-primary) 0%, var(--app-primary-hover) 45%, var(--app-success-text) 100%);
	padding: 22px 24px;
	border-radius: 12px;
	box-shadow: 0 8px 28px rgba(29, 78, 216, 0.22);
}

.welcome-icon {
	width: 56px;
	height: 56px;
	background: rgba(255, 255, 255, 0.14);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 16px;

	i {
		font-size: 28px;
		color: var(--app-surface);
	}
}

.welcome-text {
	h1 {
		margin: 0;
		font-size: 24px;
		font-weight: 600;
		color: var(--app-surface);
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
	}

	p {
		margin: 6px 0 0 0;
		font-size: 13px;
		color: rgba(255, 255, 255, 0.85);
	}
}

.workbench-content {
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 4px;
}

.statistics-row {
	width: 100%;
}

.customer-row {
	width: 100%;
}

.chart-row {
	width: 100%;
	min-height: 400px;
}

@media (max-width: 1200px) {
	.workbench {
		padding: 12px;
	}

	.welcome-section {
		padding: 16px 20px;
	}

	.welcome-icon {
		width: 48px;
		height: 48px;

		i {
			font-size: 24px;
		}
	}

	.welcome-text {
		h1 {
			font-size: 20px;
		}
	}

	.chart-row {
		min-height: 350px;
	}
}

@media (max-width: 768px) {
	.workbench {
		padding: 8px;
	}

	.welcome-section {
		padding: 12px 16px;
	}

	.welcome-icon {
		width: 40px;
		height: 40px;
		margin-right: 12px;

		i {
			font-size: 20px;
		}
	}

	.welcome-text {
		h1 {
			font-size: 16px;
		}

		p {
			font-size: 11px;
		}
	}

	.chart-row {
		min-height: 300px;
	}
}
</style>
